import { Formik } from 'formik'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  SignInEnterCode,
  SignInResendCode,
  ContractorPortalSignInEnterCode,
  ContractorPortalSignInResendCode,
} from 'src/constants/actionTypes'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { EnterCodeFormValues } from './EnterCodeForm.interface'
import { EnterCodeSchema } from './EnterCodeForm.validator'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import { FormErrorMessage } from 'src/components/shared/form/FormErrorMessage'
import tw from 'twin.macro'
import { ResendCode } from 'src/components/shared/ResendCode'
import { Button } from 'src/components/shared/Button'

interface Props {
  partnerName?: string
  phone: string
  platform: 'client' | 'contractorPortal'
}

const initialValues: EnterCodeFormValues = {
  code: '',
}

export const EnterCodeForm = ({ partnerName, phone, platform }: Props) => {
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const handleFormSubmit = async (values: EnterCodeFormValues) => {
    setIsLoading(true)
    setError(null)

    try {
      if (platform === 'client') {
        await createAsyncAction(
          dispatch,
          SignInEnterCode.request({ ...values, phone, partnerName }),
        )
      }

      if (platform === 'contractorPortal') {
        await createAsyncAction(
          dispatch,
          ContractorPortalSignInEnterCode.request({ ...values, phone, partnerName }),
        )
      }
    } catch (err: any) {
      setError(err)
    } finally {
      setIsLoading(false)
    }
  }

  const handleResend = async () => {
    try {
      if (platform === 'client') {
        await createAsyncAction(dispatch, SignInResendCode.request({ phone, partnerName }))
      }

      if (platform === 'contractorPortal') {
        await createAsyncAction(
          dispatch,
          ContractorPortalSignInResendCode.request({ phone, partnerName }),
        )
      }
    } catch (err: any) {}
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleFormSubmit}
      validationSchema={EnterCodeSchema}
    >
      {({ handleSubmit }) => (
        <div>
          <FormikTextField name="code" css={tw`w-full mb-6`} placeholder="XX-XX-XX" />
          <FormErrorMessage css={tw`mb-6`} error={error} />
          <Button className={tw`w-full mb-6`} loading={isLoading} onClick={() => handleSubmit()}>
            Continue
          </Button>
          <ResendCode onResend={handleResend} />
        </div>
      )}
    </Formik>
  )
}
